module.exports = __webpack_public_path__ + "img/ogp_dreamocean_big.5921e9ae.jpg";